// extracted by mini-css-extract-plugin
export default {"multiSelect":"MultiSelect_multiSelect__Gt7zD"};